import { render, staticRenderFns } from "./OutlineHeader.vue?vue&type=template&id=480c3c2e&"
import script from "./OutlineHeader.vue?vue&type=script&lang=js&"
export * from "./OutlineHeader.vue?vue&type=script&lang=js&"
import style0 from "./OutlineHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports